// extracted by mini-css-extract-plugin
export default {"info":"chart_info__2aCer"};